import { render, staticRenderFns } from "./registroInstanciaFormadoraModal.vue?vue&type=template&id=1d8ef6b4&"
import script from "./registroInstanciaFormadoraModal.vue?vue&type=script&lang=js&"
export * from "./registroInstanciaFormadoraModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports